export default { free: '体验版', base: '标准版', pro: '专业版', ent: '企业版', flagship: '旗舰版' };
